const _excluded = ["className", "padding", "autoHeight", "title", "children", "disableSeparator", "actions", "skin", "as"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import cn from 'classnames';
import styles from "./Card.module.scss";
import { Typography } from "../Typography";
export function Card(props) {
  const {
    className,
    padding,
    autoHeight,
    title,
    children,
    disableSeparator,
    actions,
    skin = 'default',
    as
  } = props,
        rest = _objectWithoutProperties(props, _excluded);

  const Component = as || 'div';
  return /*#__PURE__*/React.createElement(Component, _extends({}, rest, {
    className: cn(styles.root, [styles[skin + 'Skin']], {
      [styles[padding + 'Padding']]: !!padding,
      [styles.autoHeight]: autoHeight
    }, className)
  }), title && /*#__PURE__*/React.createElement("div", {
    className: styles.titleRow
  }, /*#__PURE__*/React.createElement(Typography, {
    weight: "normal",
    variant: "h5"
  }, title), actions && /*#__PURE__*/React.createElement("div", {
    className: styles.actions
  }, actions)), title && !disableSeparator && /*#__PURE__*/React.createElement(Separator, null), children);
}

const Separator = () => /*#__PURE__*/React.createElement("div", {
  style: {
    width: '100%',
    minHeight: '1px',
    backgroundColor: 'var(--grey-semi)'
  }
});